import { render, staticRenderFns } from "./EnvelopeTemplateList.vue?vue&type=template&id=021c062a&scoped=true&"
import script from "./EnvelopeTemplateList.vue?vue&type=script&lang=js&"
export * from "./EnvelopeTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021c062a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCol,VDialog})
